module.exports = __webpack_public_path__ + "static/media/lessons-active.4fb0b652.svg";